<template>
  <div class="preferences-fields">
    <Grid gap="var(--r-space-md)">
      <RCheckbox
        v-for="preference of emailPreferences"
        :key="preference.id"
        v-model="preferences"
        :label="preference.label"
        :val="preference.id"
      />
    </Grid>
  </div>
</template>

<script>
// Libraries
import { cloneDeep } from 'lodash'

export default {
  props: {
    initialPreferences: Array
  },

  data() {
    return {
      preferences: cloneDeep(this.initialPreferences.map(preference => preference.id))
    }
  },

  methods: {
    //Access from parent
    getPayload() {
      return this.preferences
    }
  }
}
</script>

<style lang="scss" scoped></style>
